export const SEARCH_TYPE = "search_type";
export const FIRST_NAME = "first_name";
export const LAST_NAME = "last_name";
export const SEARCH_CRITERIA = "search_criteria";

export const BOM_POSITION_ID = "bomPositionId";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const USER_IDS = "userIds";
export const COMMUNITY_ID = "communityId";

export const searchType = [
  { label: "User ID", value: "userName" },
  { label: "Alternate Login ID", value: "alternateLoginId" },
  { label: "Name", value: "name" },
  { label: "Mobile No.", value: "mobileNo" },
  { label: "Email ID", value: "email" },
];

export const dummyData = [
  {
    id: 1,
    userId: "1234567890",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "1234567890",
    positionName: "Manager",
  },
  {
    id: 2,
    userId: "1234567890",
    firstName: "Jane",
    lastName: "Doe",
  },
  {
    id: 3,
    userId: "1234567890",
    firstName: "John",
    lastName: "Doe",
  },
];
